var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Oh dear, network issues!!!")]),_c('router-link',{attrs:{"to":{ name: 'event-list' }}},[_vm._v("< Back to Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }